import { ref } from "vue";
import { defineStore } from "pinia";

export const usePausedTimepointStore = defineStore("paused_timepoint", () => {
  const isActive = ref(false);

  const activate = () => {
    isActive.value = true;
  };

  const reset = () => {
    isActive.value = false;
  };

  return {
    isActive,
    activate,
    reset,
  };
});
